<template>
    <div class>
      <div class="ba_f outmain">
        <div class="shuju_title">
          <div class="shuju_title_text">
            <span>筛选条件</span>
          </div>
        </div>
        <el-form :inline="false" :model="form" class="demo-form-inline" label-width="100px">
          <div class="flex ba_f">
            <el-form-item label="查询日期：" class="mar_t20">
              <div class="flex-bet">
                <div>
                  <el-radio-group v-model="form.timeType" @change="selectType">
                    <el-radio-button label="1">今天</el-radio-button>
                    <el-radio-button label="2">近七天</el-radio-button>
                    <el-radio-button label="3">近十五天</el-radio-button>
                    <el-radio-button label="4">自定义时间</el-radio-button>
       
                  </el-radio-group>
                  <span class="mar_l20" v-if="form.timeType=='4'">
                  <el-date-picker v-model="form.time" type="daterange" range-separator="至" start-placeholder="开始日期"
                                  end-placeholder="结束日期" format="yyyy年MM月dd日" :picker-options="pickerOptions" @change="selectType"></el-date-picker>
                </span>
     
                </div>
              </div>
            </el-form-item>
          </div>
          <div class="flex ba_f">
            <el-form-item label="选择动态：">
              <div class="mar_l20">
                <el-select v-model="form.notes_id" placeholder="请选择" @change="changeStore" filterable>
                  <el-option v-for="item in notesArr" :key="item.notes_id" :label="item.name+'(ID:'+item.notes_id+')'"
                            :value="item.notes_id"></el-option>
                </el-select>
              </div>
            </el-form-item>
          </div>
        </el-form>
      </div>

      <div class="mar_t20 ba_f outmain">
        <div class="shuju_title">
          <div class="shuju_title_text">
            <span>整体看板</span>
          </div>
          <!--    <div class="fon_12 ab r0 mar_r10 color_9">更新时间：2020-09-04 13:32:59</div>-->
        </div>
        <div class="main-icon flex t_l mar_t20">
        

          <div class="flex-1 t_l pad_20 borderBG mar_r20">
            <div class="flex-bet flex-y-top">
              <div>
                <p class="title6 fon_14">点赞</p>
                <p class="fon_30 title35 lh16 pad_tb_20 wei">{{ notesRecord.like_num || 0 }}</p>
                <!-- <p class="fon_12 title6 lh25">服务费支出：{{ jeData.commission || 0 }}</p> -->
              </div>
            </div>
          </div>

          <div class="flex-1 t_l pad_20 borderBG mar_r20">
            <div class="flex-bet flex-y-top">
              <div>
                <p class="title6 fon_14">收藏</p>
                <p class="fon_30 title35 lh16 pad_tb_20 wei">{{ notesRecord.collect_num || 0 }}</p>
                <!-- <p class="fon_12 title6 lh25">服务费支出：{{ jeData.commission || 0 }}</p> -->
              </div>
            </div>
          </div>
          <div class="flex-1 t_l pad_20 borderBG mar_r20">
            <div class="flex-bet flex-y-top">
              <div>
                <p class="title6 fon_14">点击数</p>
                <p class="fon_30 title35 lh16 pad_tb_20 wei">{{ notesRecord.click_num || 0 }}</p>
                <!-- <p class="fon_12 title6 lh25">客单价：{{ jeData.unitPrice || 0 }}</p> -->
              </div>
            </div>
          </div>
        </div>
        <div id="zhentiEch" style="height: 360px;" class="mar_t20"></div>
      </div>


      <div class="mar_t20 ba_f outmain pad_20">
  <div class="shuju_title">
    <div class="shuju_title_text">
      <span>话题概况</span>
    </div>
  </div>
  <div class="flex-bet chart-container">
    <!-- 主图表区 -->
    <div class="bflex-7 chart-main">
      <div  id="zhentiEch3" style="height:360px"></div>
      <!-- <div v-else class="empty-chart">暂无趋势数据</div> -->
    </div>
    
    <!-- 右侧统计面板 -->
    <div class="bflex-3 stat-panel">
      <!-- 指标卡片 -->
      <div class="stat-card-group">
        <div class="stat-card">
          <div class="stat-label">
            <i class="el-icon-data-analysis"></i>
            话题数量
          </div>
          <div class="stat-value">{{ jeData.topic_count | 0 }}</div>
        </div>
        <div class="stat-card">
          <div class="stat-label">
            <i class="el-icon-c-scale-to-original"></i>
            使用频率
          </div>
          <div class="stat-value">{{ jeData.total_usage | 0 }}</div>
        </div>
      </div>

      <!-- 热门话题 -->
      <div class="hot-topics">
        <h3 class="hot-title">
          <i class="el-icon-star-off"></i>
          热门使用话题 TOP10
        </h3>
        <div v-if="topics.length" class="topic-list">
          <div v-for="(item,index) in topics" 
               :key="item.name" 
               class="topic-item"
               @mouseover="highlightTopic(item.name)">
            <div class="topic-rank">
              <span :class="['rank-badge', {top3: index < 3}]">
                {{ index+1 }}
              </span>
            </div>
            <div class="topic-info">
              <div class="topic-name text-ellipsis">{{ item.name || '未知话题' }}</div>
              <div class="topic-stats">
                <span class="usage-count">{{ item.usage | 0 }}次</span>
                <span class="sort-order">优先级：{{ item.sort }}</span>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="empty-tips">暂无热门话题数据</div>
      </div>
    </div>
  </div>
</div>

    </div>
  </template>
  <script>
  import echarts from 'echarts';
  import StatisticsApi from '@/api/statistics.js';
  import NotesApi from '@/api/notes.js';
  import { changeDate } from '@/utils/index';
  export default {
    mounted() {
 
      window.addEventListener('resize', this.initchart);
    },
    created() {
    //   this.form.shopValue = this.market[0].id;
    //   this.options = this.market;
    this.getNotes();
    },
    data() {
      return {
        selectData: '',
        pickerOptions: {
          disabledDate: (time) => {
            // 计算允许的最小日期（当前月前推6个月的第一天）
            const minDate = new Date()
            minDate.setMonth(minDate.getMonth() - 6)
            minDate.setDate(1)
            minDate.setHours(0, 0, 0, 0)

            // 计算允许的最大日期（当前月最后一天）
            const maxDate = new Date()
            maxDate.setMonth(maxDate.getMonth() + 1, 0)
            maxDate.setHours(23, 59, 59, 999)

            // 禁用不在时间范围内的日期
            return time < minDate || time > maxDate
          }
        },
        dddata: {},
        zhData: {},
        jeData: {},
        jyData: {},
        form: {
          shopValue: '',
          timeType: '3',
          time: [new Date(), new Date()],
          Mtime: '',
          notes_id:0
        },
        options: [
          {
            value: '1',
            label: '全部'
          }
        ],
        options2: [
          {
            value: '1',
            label: '自然日'
          }
          // {
          //     value: '2',
          //     label: '自然月'
          // }
        ],
        tableData: [],
        tableData2: [],

        echarts2_option: {
          color: ['#FF6B6B', '#4ECDC4', '#edff68'], // 调整为三色系
          tooltip: {
            trigger: 'axis',
            formatter: function(params) {
              let tip = params[0].name + '<br/>';
              params.forEach(item => {
                tip += `${item.marker} ${item.seriesName}: ${item.value}<br/>`;
              });
              return tip;
            }
          },
          legend: {
            data: ['点赞数', '收藏数', '点击数'] // 对应接口返回的字段
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            axisTick: {
              show: false
            },
            axisLabel: {
              color: '#333',
              fontSize: 12
            },
            axisLine: {
              lineStyle: {
                color: '#f7f7f7',
                width: 2
              }
            },
            data: [] // 绑定月份数据
          },
          yAxis: {
            type: 'value',
            axisTick: { show: false },
            axisLine: { show: false },
            axisLabel: {
              color: '#333',
              fontSize: 12
            },
            splitLine: {
              lineStyle: {
                type: 'dotted',
                color: '#DDDDDD'
              }
            }
          },
          series: [
            {
              name: '点赞数',
              type: 'line',
              smooth: true,
              areaStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: 'rgba(255,107,107,0.6)' },
                  { offset: 1, color: 'rgba(255,107,107,0.05)' }
                ])
              },
              data: []
            },
            {
              name: '收藏数',
              type: 'line',
              smooth: true,
              areaStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: 'rgba(78,205,196,0.6)' },
                  { offset: 1, color: 'rgba(78,205,196,0.05)' }
                ])
              },
              data: []
            },
            {
              name: '点击数',
              type: 'line',
              smooth: true,
              areaStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: 'rgba(69,183,209,0.6)' },
                  { offset: 1, color: 'rgba(69,183,209,0.05)' }
                ])
              },
              data: []
            }
          ]
        },
        echarts3Option: {
        color: ['#1890FF', '#2FC25B'],
        tooltip: {
          trigger: 'axis',
          formatter: params => {
            let tip = `<strong>${params[0].name}</strong><br>`
            params.forEach(item => {
              tip += `${item.marker} ${item.seriesName}: ${item.value.toLocaleString()}<br>`
            })
            return tip
          }
        },
        legend: {
          data: ['话题数量', '使用频率'],
          bottom: 10
        },
        grid: {
          left: 60,
          right: 40,
          top: 40,
          bottom: 40,
          containLabel: true
        },
        xAxis: {
          type: 'category',
          axisLabel: {
            rotate: 45
          },
          data: []
        },
        yAxis: [
          {
            type: 'value',
            name: '话题数量',
            axisLine: { show: false },
            splitLine: { lineStyle: { type: 'dashed' } }
          },
          {
            type: 'value',
            name: '使用次数',
            axisLine: { show: false },
            splitLine: { show: false }
          }
        ],
        series: [
          {
            name: '话题数量',
            type: 'bar',
            barWidth: '30%',
            itemStyle: {
              borderRadius: [4, 4, 0, 0]
            },
            data: []
          },
          {
            name: '使用频率',
            type: 'line',
            yAxisIndex: 1,
            smooth: true,
            symbol: 'circle',
            symbolSize: 8,
            lineStyle: { width: 3 },
            data: []
          }
        ]
      },


        notesArr:[],
        notesRecord:{},
        jeData:{},
        topics:[],
       
      };
    },
    computed: {
     
    },
    methods: {
        selectType(){

          this.getNotesRecord();
        },
        isNull(value) {
          if (value) {
            return false
          }
          return true
        },
        // 高亮关联数据点
        highlightTopic(topicName) {
          // 这里可添加图表高亮逻辑
        },
        getNotesRecord(){
          let self = this;
          window.addEventListener('resize', this.initchart);
    
          let startTime = '';
          let endTime = '';
          if (this.form.time) {
            startTime = changeDate(this.form.time[0]);
            endTime = changeDate(this.form.time[1]);
          }


          let Params = {
            notes_id:self.form.notes_id,
            timeType:this.form.timeType,
            startTime,
            endTime,
          };

          self.loading = true;
          NotesApi.getNotesRecord(Params, true)
            .then(data => {
              self.loading = false;
              self.notesRecord = data.data.list.stats;
               self.echarts2_option.series[0].data = data.data.list.chart.series['点赞数'];
               self.echarts2_option.series[1].data = data.data.list.chart.series['收藏数'];
               self.echarts2_option.series[2].data = data.data.list.chart.series['点击数'];
           
              self.echarts2_option.xAxis.data =data.data.list.chart.xAxis;
              self.zhentiEch();



            })
            .catch(error => {
            });

            NotesApi.getTopicStats(Params, true)
            .then(data => {
              self.loading = false;
              self.jeData = data.data.list.stats
              self.topics =  data.data.list.topics
      
              self.echarts3Option.series[0].data = data.data.list.chart.series['话题数量'];
              self.echarts3Option.series[1].data = data.data.list.chart.series['使用频率'];

              self.echarts3Option.xAxis.data = data.data.list.chart.xAxis;
              self.zhentiEch3();


            })
            .catch(error => {
            });
        },
        getNotes(){
          let self = this;
          let Params = {};

          self.loading = true;
          NotesApi.lists(Params, true)
            .then(data => {
              self.loading = false;
              self.notesArr = data.data;
              self.form.notes_id = self.notesArr[0].notes_id
              self.getNotesRecord();
            })
            .catch(error => {
            });
        },
 
      initchart() {

        let myChart2 = echarts.init(document.getElementById('zhentiEch'));
        let myChart3 = echarts.init(document.getElementById('zhentiEch3'));

        myChart2.resize();
        myChart3.resize();
      },


      zhentiEch() {
        let myChart = echarts.init(document.getElementById('zhentiEch'));
        myChart.setOption(this.echarts2_option, true);
      },
      zhentiEch3() {
        let myChart = echarts.init(document.getElementById('zhentiEch3'));
        myChart.setOption(this.echarts3Option, true);
      },
      changeTime() {
        this.realRecord();
      },
      mainEch32() {
        let myChart = echarts.init(document.getElementById('mainEch32'))
        myChart.setOption(this.echarts32_option, true)
      },
      mainEch33() {
        let myChart = echarts.init(document.getElementById('mainEch33'))
        myChart.setOption(this.echarts33_option, true)
      },

      changeStore() {
        // this.realRecord();
        // this.recordData();
        this.getNotesRecord();
        //获取动态的收藏
      }
    }
  };
  </script>
  <style lang="scss" scoped>
  .title6 {
    color: #666;
    font-size: 14px;
  }
  
  .title35 {
    color: #353535;
  }
  
  .tongji_icon {
    width: 40px;
    height: 40px;
    font-size: 20px;
  }
/* 新增样式 */
.chart-container {
  gap: 20px;
}

.stat-card {
  background: #f8fafc;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 12px;
}
.stat-label {
  color: #666;
  font-size: 13px;
  display: flex;
  align-items: center;
  gap: 6px;
}
.stat-value {
  font-size: 24px;
  font-weight: 600;
  color: #1890FF;
  margin-top: 8px;
}

.hot-title {
  color: #333;
  font-size: 16px;
  margin: 15px 0;
}

.topic-item {
  display: flex;
  align-items: center;
  padding: 12px;
  margin: 6px 0;
  background: #fff;
  border-radius: 6px;
  transition: all 0.3s;
}
.topic-item:hover {
  box-shadow: 0 2px 12px rgba(0,0,0,0.1);
}

.rank-badge {
  display: inline-block;
  width: 24px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  background: #f0f2f5;
  border-radius: 50%;
  font-size: 13px;
}
.rank-badge.top3 {
  background: #1890FF;
  color: white;
}

.topic-info {
  flex: 1;
  margin-left: 12px;
}
.topic-name {
  max-width: 120px;
  font-weight: 500;
}
.usage-count {
  color: #2FC25B;
  font-size: 13px;
}
.sort-order {
  color: #999;
  font-size: 12px;
  margin-left: 8px;
}

.empty-chart, .empty-tips {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
}
  </style>
  


// WEBPACK FOOTER //
// src/views/statistics/new/notes.vue